import { colors } from 'baseui/tokens';
import stylesColors from 'common/styles/styles.colors';
import { string2money } from 'common/utils/string';
import DrawerHeader from 'components/common/drawer/drawer-header';
import { DrawerBody } from 'components/common/drawer/styles';
import Separator from 'components/common/separator';
import Text from 'components/elements/text';
import { Container } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import { OtherContainer, TotalContent, TotalItemContent } from '../../style';

interface Props {
  onClose: () => void;
  flightSales: any[];
  total: number;
}

export default function SummaryDrawer(props: Props) {
  const { t } = useTranslation();
  const { onClose } = props;

  return (
    <>
      <DrawerHeader
        onClose={onClose}
        title={t('ticketSales:flight_sales_details')}
      />
      <DrawerBody>
        {props.flightSales.map((schedule, idx) => {
          // if (!schedule.isSelected) {
          //   return null;
          // }
          const someGuestSelected = schedule.flightSaleGuests.some(
            (curr) => curr.isSelected,
          );
          const someAddonsSelected = schedule.flightSaleAddOns.some(
            (curr) => curr.isSelected,
          );
          if (!someGuestSelected && !someAddonsSelected) {
            return null;
          }
          const guestFee = schedule.flightSaleGuests
            .filter((curr) => curr.isSelected)
            .reduce((prev, curr) => prev + curr.price, 0);
          const addonsFee = schedule.flightSaleAddOns
            .filter((curr) => curr.isSelected)
            .reduce((prev, curr) => prev + curr.price, 0);
          return (
            <React.Fragment key={schedule.id}>
              <Container key={schedule.id} style={{ height: 'auto' }}>
                <Text
                  variant="LabelMedium"
                  $style={{ color: stylesColors.primaryDefault }}
                >
                  {t('ticketSales:schedule_extra', {
                    extra: `${idx + 1} - ${schedule.bookingCode}`,
                  })}
                </Text>
                <Separator gap={16} />
                <OtherContainer>
                  <Text variant="LabelSmall">{t('common:reschedule')}</Text>
                  <Text variant="LabelSmall">{`Rp ${string2money(
                    guestFee + addonsFee,
                  )}`}</Text>
                </OtherContainer>
              </Container>
              <Separator gap={24} />
            </React.Fragment>
          );
        })}
        <Separator gap={16} direction="vertical">
          <div style={{ height: 1, backgroundColor: colors.gray200 }} />
        </Separator>
        <TotalContent>
          <TotalItemContent>
            <Text variant="LabelMedium">{t('common:total')}:</Text>
            <Separator gap={8} />
            <Text variant="HeadingXSmall">{`Rp ${string2money(
              props.total,
            )}`}</Text>
          </TotalItemContent>
        </TotalContent>
      </DrawerBody>
    </>
  );
}
